<template>
    <div class="card">
        <h4>Завантажити у Excel список товарів що використовується у конфігураторі</h4>
        <Button icon="pi pi-external-link" style="width: 150px;" label="КРМ" @click="getExcel('krm')" />
        <Button icon="pi pi-external-link" style="width: 150px;" label="АВР" @click="getExcel('avr')" />
        <Button icon="pi pi-external-link" style="width: 150px;" label="Я5000" @click="getExcel('ya5000')" />
        <Button icon="pi pi-external-link" style="width: 150px;" label="ЩО90" @click="getExcel('sho90')" />
        <Button icon="pi pi-external-link" style="width: 150px;" label="ЩО125" @click="getExcel('sho125')" />
        <Button icon="pi pi-external-link" style="width: 150px;" label="Плавні пуски" @click="getExcel('plavni_spuski')" />
        <Button icon="pi pi-external-link" style="width: 150px;" label="Клемні ряди" @click="getExcel('klemnyi_riad')" />
    </div>
</template>

<script>
import axios from "axios";
import AppLayout from "@/Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import swal from 'sweetalert2';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import Toast from 'primevue/toast';
import {FilterMatchMode} from "primevue/api";
import moment from "moment";

export default {

    components: {
        DataTable,
        Column,
        InputText,
        swal,
        Dialog,
        Button,
        Dropdown,
        Toast,
    },
    layout: AppLayout,

    data() {
        return {

        }
    },

    methods: {
        getExcel(configurator) {
            axios.post(this.route('api.configurator-products.excel.get'), {
                configurator: configurator,
            })
            .then((response) => {
                this.summarize = false
                var fileURL = response.data.data;
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', response.data.name);
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch((error) => {
                this.summarize = false
                console.log(error);
                window.scroll(0, 0);
            })
        },
    }
};
</script>

<style scoped>
.card {
    display: flex;
    gap: 20px;
    flex-direction: column;
}
</style>
